import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'ag-grid-enterprise';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { LicenseManager } from "ag-grid-enterprise";
LicenseManager.setLicenseKey("CompanyName=Aerodyne,LicensedApplication=vertikaliti,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-012423,ExpiryDate=16_December_2021_[v2]_MTYzOTYxMjgwMDAwMA==e835b76f6be002f10be1917dd675c594");


declare var Cesium;
declare var proj4;

if (environment.production) {
  enableProdMode();
}

Cesium.buildModuleUrl.setBaseUrl('/assets/cesium/');
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
